module.exports = __webpack_public_path__ + "img/annoucement.881e2a58.png";